/**
 * @generated SignedSource<<00a61887c0d816e3259708ea3392cd7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Segment = "business" | "personal" | "sparkdigitalshop";
export type PlansAccountListQuery$variables = {};
export type PlansAccountListQuery$data = {
  readonly me: {
    readonly accountList: ReadonlyArray<{
      readonly accountId: string;
      readonly segment: Segment;
    }>;
  };
};
export type PlansAccountListQuery = {
  response: PlansAccountListQuery$data;
  variables: PlansAccountListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountList",
        "kind": "LinkedField",
        "name": "accountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "segment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlansAccountListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PlansAccountListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f2225091a0df261a7899576ca46ac484",
    "id": null,
    "metadata": {},
    "name": "PlansAccountListQuery",
    "operationKind": "query",
    "text": "query PlansAccountListQuery {\n  me {\n    accountList {\n      accountId\n      segment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d99345ccde9d93f96cd740a4db55b5d2";

export default node;
